import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ControlledTextField from 'src/shared/components/form/controlledTextField';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';

export const CustomerSettingsInternalInformation = () => {
  const { t } = useTranslation();

  return (
    <>
      <Typography mb={2} sx={{ fontWeight: 500, color: 'text.secondary' }}>
        {t('customer:detailPage.internalInformation')}
      </Typography>
      <Box px={1}>
        <GridWrapper>
          <Grid item xs={12} sm={6} sx={{ marginBottom: { xs: 1, md: 0 } }}>
            <ControlledTextField name='custom3' label={t('customer:detailPage.custom3')} />
          </Grid>
          <Grid item xs={12} sm={6} sx={{ marginBottom: { xs: 1, md: 0 } }}>
            <ControlledTextField name='custom10' label={t('customer:detailPage.custom10')} />
          </Grid>
        </GridWrapper>
      </Box>
    </>
  );
};
